import React from 'react';
import { Typography } from 'antd';
import { HProps } from '../interfaces';
import styles from './H1.module.scss';

export const H1: React.FC<HProps> = ({ className, children }) => (
  <Typography.Title
    className={[styles.text, className].filter(Boolean).join(' ')}
  >
    {children}
  </Typography.Title>
);
